import React, { useState, useEffect } from "react";


const ImageModal = (data) => {
  const [isOpen, setIsOpen] = useState(false);

  // Close when pressing Escape
    useEffect(() => {
      const handleKeyDown = (e) => {
        if (e.key === "Escape") {
          setIsOpen(false);
        }
      };
  
      window.addEventListener("keydown", handleKeyDown);
  
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, []);

  return (
    <div className="ml-0 mb-4 w-full md:w-1/3 ml-3.5 pt-2">
      <img
        src={data.img}
        alt={data.alt}
        className="cursor-pointer rounded shadow hover:opacity-80 transition"
        onClick={() => setIsOpen(true)}
      />

      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50"
          onClick={() => setIsOpen(false)}
        >
          <img
            src={data.img}
            alt={data.alt}
            className="max-w-full max-h-full rounded shadow-lg"
          />
        </div>
      )}
    </div>
  );
};

export default ImageModal;